<template>
  <section
    class="component-e360d18d"
    resmed-component-name="callout_full_width_icon-line_info_text"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
      'margin-bottom': acf.layout['offset'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2" v-bind:style="style">
        <div class="row justify-content-center">
          <div
            class="col-md-10"
            v-bind:class="{
              'text-center': acf.layout['text-align'] === 'center',
            }"
          >
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-if="acf.headline">{{ acf.headline }}</h2>
            <div v-html="acf.content"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-e360d18d", // callout_full_width_icon-line_info_text
  props: ["acf"],
  data() {
    return {
      style: {
        transform: `translateY(${this.acf.layout.offset})`,
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        if (val === "xs" || val === "sm") {
          this.style["padding-top"] = this.acf.layout["padding-top"]["xs"];
          this.style["padding-bottom"] =
            this.acf.layout["padding-bottom"]["xs"];
        } else {
          this.style["padding-top"] = this.acf.layout["padding-top"]["md"];
          this.style["padding-bottom"] =
            this.acf.layout["padding-bottom"]["md"];
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-e360d18d {
  margin-bottom: -2rem;

  @media (min-width: 768px) {
    margin-bottom: -7rem;
  }
}

.component {
  h2 {
    position: relative;
    margin: 0 0 1.25rem 0;

    @extend %eyebrow-center;
  }

  .container {
    background: $cc-resmed-white;
    box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
    border-radius: 6px;
    transform: translateY(-2rem);

    @media (min-width: 768px) {
      transform: translateY(-7rem);
    }

    padding-top: 5rem;
    padding-bottom: 4rem;

    @media (max-width: 575px) {
      max-width: 80vw;
    }

    @media (min-width: 768px) {
      padding-top: 6rem;
      padding-bottom: 5rem;
    }
  }
}
</style>